// extracted by mini-css-extract-plugin
export default {"listItem":"PaymentTerminalsPanel_listItem__s6y48","serial":"PaymentTerminalsPanel_serial__bLZo+","skels":"PaymentTerminalsPanel_skels__H-QxC"};